import { devtools } from 'config/devtools'
import { IS_DANONE_ENV, IS_JUME_ENV } from 'constants/env'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface UseLastSession {
  page?: string
  profileId?: number
  activeProjectId?: number
  isNavigated: boolean
  setIsNavigated: (a: boolean) => void
  setPage: (a: string) => void
  setProfileId: (a?: number) => void
  setActiveProjectId: (a?: number) => void
}

export const useLastSession = create<UseLastSession>()(
  devtools(
    persist(
      (set) => ({
        page: '',
        isNavigated: false,
        setIsNavigated: (isNavigated) => {
          if (IS_DANONE_ENV) {
            return
          }
          set({ isNavigated })
        },
        setPage: (page) => {
          if (!IS_JUME_ENV) {
            return
          }
          set({ page })
        },
        setProfileId: (profileId) => {
          if (!IS_JUME_ENV) {
            return
          }
          set({ profileId })
        },
        setActiveProjectId: (activeProjectId) => {
          if (!IS_JUME_ENV) {
            return
          }
          set({ activeProjectId })
        },
      }),
      {
        name: 'lastSession',
      },
    ),
    {
      store: 'lastSession',
    },
  ),
)
